import Treinamento from "./TreinamentoList";

export default function Treinamentos() {

  return (
    <>
      <Treinamento />
    </>
  )

}